var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-3 text-center"},[_c('v-card-title',{staticClass:"justify-center"},[_vm._v(_vm._s(_vm.number))]),_c('v-card-subtitle',{staticClass:"mt-0"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }